import { getBaseNftEventContext } from "@/app/nft/utils/get-base-nft-event-context"
import type { EventContext, Flow } from "@/instrumentation/logger/types"
import * as amplitude from "@amplitude/analytics-browser"
import type { NftMiniature } from "@anaconda/core/nft/types"
import {
  TransactionEvent,
  getTransactionErrorMessage,
} from "./transaction-event"

type LoggerLike =
  | {
      api: {
        pushEvent: (eventName: string, context: EventContext) => void
      }
    }
  | undefined

export function trackTransactionStarted({
  logger,
  flow,
  nft,
}: {
  logger: LoggerLike
  flow: Flow
  nft: NftMiniature
}) {
  const context: EventContext = {
    flow,
    ...getBaseNftEventContext(nft),
  }
  logger?.api.pushEvent(TransactionEvent.Started, context)
  amplitude.track(TransactionEvent.Started, context)
}

export function trackTransactionCompleted({
  logger,
  flow,
  nft,
  txId,
}: {
  logger: LoggerLike
  flow: Flow
  nft: NftMiniature
  txId?: string
}) {
  const base: EventContext = {
    flow,
    ...getBaseNftEventContext(nft),
  }
  const context = txId ? { ...base, transactionId: txId } : base
  logger?.api.pushEvent(TransactionEvent.Completed, context)
  amplitude.track(TransactionEvent.Completed, context)
}

export function trackTransactionFailed({
  logger,
  flow,
  nft,
  error,
}: {
  logger: LoggerLike
  flow: Flow
  nft: NftMiniature
  error: unknown
}) {
  const context = {
    flow,
    ...getBaseNftEventContext(nft),
    error: getTransactionErrorMessage(error),
  } satisfies EventContext
  logger?.api.pushEvent(TransactionEvent.Failed, context)
  amplitude.track(TransactionEvent.Failed, context)
}
